import styles from './disinfectVideo.module.css';
import gsap from 'gsap';
import ScrollTrigger from 'gsap/ScrollTrigger';
import { useEffect } from 'react';
import { useRef } from 'react';
import DOMPurify from 'dompurify';
import VideoAlert from '../../video-alert';
gsap.registerPlugin(ScrollTrigger);
const DisinfectVideo = ({ textData,language }) => {
  const ctnRef = useRef(null);
  // const text1HRef = useRef(null);
  const text1PRef = useRef(null);
  const text2HRef = useRef(null);
  const text3Ref = useRef(null);
  const text4Ref = useRef(null);
  const watchVideoButtonRef = useRef(null);
  const maskRef = useRef(null);
  const canvasRef = useRef(null);
  const productNameRef = useRef(null);
  const sloganRef = useRef(null);
  const params1Ref = useRef(null);
  const params2Ref = useRef(null);
  const params3Ref = useRef(null);
  const params4Ref = useRef(null);
  const params5Ref = useRef(null);
  const params6Ref = useRef(null);
  const params7Ref = useRef(null);

  useEffect(() => {
    new VideoAlert({
      havePathElement: `.${styles.watchVideoButton}`,
    });
  }, []);

  const disinfectAnimation = () => {
    const currentFrame = (index) => {
      if (index > 69) {
        return `https://zhiyun-website-shenzhen.oss-cn-shenzhen.aliyuncs.com/detail/ozone-speaker/zhiyunlife-ozonespeaker-animation-1/zhiyunlife-ozonespeaker-animation-${(
          index + 1
        )
          .toString()
          .padStart(5, '0')}.jpg`;
      } else {
        return `https://bucket.zhiyun-tech.com/detail/ozone-speaker/zhiyunlife-ozonespeaker-animation-1/zhiyunlife-ozonespeaker-animation-${(
          index + 1
        )
          .toString()
          .padStart(5, '0')}.png`;
      }
    };

    const canvas = canvasRef.current;
    // console.log(canvas);
    const context = canvas.getContext('2d');
    canvas.width = 1920;
    canvas.height = 1080;
    const frameCount = 201;
    const images = [];
    const xdbFrames = {
      frame: 23,
    };

    for (let i = 0; i < frameCount; i++) {
      const img = new Image();
      img.src = currentFrame(i);
      // console.log(img.src);
      images.push(img);
    }

    images[xdbFrames.frame].onload = render;

    function render() {
      // console.log(xdbFrames.frame);
      context.clearRect(0, 0, canvas.width, canvas.height);
      context.drawImage(images[xdbFrames.frame], 0, 0);
    }

    let tl = gsap.timeline({
      scrollTrigger: {
        trigger: ctnRef.current,
        start: 'top top',
        pin: true,
        end: '650%',
        pinSpacing: true,
        scrub: 1.4,
      },
    });

    tl.to(xdbFrames, {
      frame: 117,
      snap: 'frame',
      onUpdate: render,
      duration: 12,
    });

    // tl.to(
    //   sloganRef.current,
    //   {
    //     y: -100,
    //     duration: 4,
    //   },
    //   0,
    // );

    tl.to(
      sloganRef.current,
      {
        opacity: 0,
        duration: 1,
      },
      2,
    );

    // tl.to(
    //   productNameRef.current,
    //   {
    //     y: -100,
    //     duration: 4,
    //   },
    //   0.5,
    // );

    tl.to(
      productNameRef.current,
      {
        opacity: 0,
        duration: 1,
      },
      2,
    );

    tl.to(
      text1PRef.current,
      {
        y: 'var(--effect-offset-y)',
        duration: 2,
      },
      2,
    );

    tl.to(
      text1PRef.current,
      {
        opacity: 1,
        duration: 0.5,
      },
      2,
    );

    tl.to(
      text1PRef.current,
      {
        opacity: 0,
        duration: 1,
      },
      3,
    );

    tl.to(
      watchVideoButtonRef.current,
      {
        y: 'var(--effect-offset-y)',
        duration: 2,
      },
      2.2,
    );

    tl.to(
      watchVideoButtonRef.current,
      {
        opacity: 1,
        duration: 0.5,
      },
      2.2,
    );

    tl.to(
      watchVideoButtonRef.current,
      {
        opacity: 0,
        duration: 1,
      },
      3.2,
    );

    tl.to(
      text2HRef.current,
      {
        y: 'var(--effect-offset-y)',
        duration: 2,
      },
      4,
    );

    tl.to(
      text2HRef.current,
      {
        opacity: 1,
        duration: 0.5,
      },
      4,
    );

    tl.to(
      text2HRef.current,
      {
        opacity: 0,
        duration: 1,
      },
      5,
    );

    tl.to(
      text3Ref.current,
      {
        y: 'var(--effect-offset-y)',
        duration: 2,
      },
      8,
    );

    tl.to(
      text3Ref.current,
      {
        opacity: 1,
        duration: 0.5,
      },
      8,
    );

    // tl.to(
    //   canvasRef.current,
    //   {
    //     transform: 'translateX(var(--effect-product-offset-x))',
    //     duration: 6,
    //   },
    //   6,
    // );

    tl.to(
      params1Ref.current,
      {
        '--effect-line-scaleX': 1,
        '--effect-line-opacity': 1,
        duration: 0.5,
      },
      10,
    );

    tl.to(
      params1Ref.current,
      {
        '--effect-text-opacity': 1,
        duration: 0.5,
      },
      10.1,
    );

    tl.to(
      params2Ref.current,
      {
        '--effect-line-scaleX': 1,
        '--effect-line-opacity': 1,
        duration: 0.5,
      },
      10.3,
    );

    tl.to(
      params2Ref.current,
      {
        '--effect-text-opacity': 1,
        duration: 0.5,
      },
      10.4,
    );

    tl.to(
      params3Ref.current,
      {
        '--effect-line-scaleX': 1,
        '--effect-line-opacity': 1,
        duration: 0.5,
      },
      10.6,
    );

    tl.to(
      params3Ref.current,
      {
        '--effect-text-opacity': 1,
        duration: 0.5,
      },
      10.7,
    );

    tl.to(
      params4Ref.current,
      {
        '--effect-line-scaleX': 1,
        '--effect-line-opacity': 1,
        duration: 0.5,
      },
      10.9,
    );

    tl.to(
      params4Ref.current,
      {
        '--effect-text-opacity': 1,
        duration: 0.5,
      },
      11,
    );

    //

    tl.to(
      params1Ref.current,
      {
        '--effect-line-opacity': 0,
        duration: 0.5,
      },
      12,
    );

    tl.to(
      params1Ref.current,
      {
        '--effect-text-opacity': 0,
        duration: 0.5,
      },
      12.1,
    );

    tl.to(
      params2Ref.current,
      {
        '--effect-line-opacity': 0,
        duration: 0.5,
      },
      12,
    );

    tl.to(
      params2Ref.current,
      {
        '--effect-text-opacity': 0,
        duration: 0.5,
      },
      12.1,
    );

    tl.to(
      params3Ref.current,
      {
        '--effect-line-opacity': 0,
        duration: 0.5,
      },
      12,
    );

    tl.to(
      params3Ref.current,
      {
        '--effect-text-opacity': 0,
        duration: 0.5,
      },
      12.1,
    );

    tl.to(
      params4Ref.current,
      {
        '--effect-line-opacity': 0,
        duration: 0.5,
      },
      12,
    );

    tl.to(
      params4Ref.current,
      {
        '--effect-text-opacity': 0,
        duration: 0.5,
      },
      12.1,
    );

    //

    tl.to(
      xdbFrames,
      {
        frame: 142,
        snap: 'frame',
        onUpdate: render,
        duration: 3,
      },
      12,
    );

    tl.to(
      params5Ref.current,
      {
        '--effect-line-scaleX': 1,
        '--effect-line-opacity': 1,
        duration: 0.5,
      },
      14,
    );

    tl.to(
      params5Ref.current,
      {
        '--effect-text-opacity': 1,
        duration: 0.5,
      },
      14.1,
    );

    tl.to(
      params6Ref.current,
      {
        '--effect-line-scaleX': 1,
        '--effect-line-opacity': 1,
        duration: 0.5,
      },
      14.3,
    );

    tl.to(
      params6Ref.current,
      {
        '--effect-text-opacity': 1,
        duration: 0.5,
      },
      14.4,
    );

    tl.to(
      params7Ref.current,
      {
        '--effect-line-scaleX': 1,
        '--effect-line-opacity': 1,
        duration: 0.5,
      },
      14.6,
    );

    tl.to(
      params7Ref.current,
      {
        '--effect-text-opacity': 1,
        duration: 0.5,
      },
      14.7,
    );

    //

    tl.to(
      params5Ref.current,
      {
        '--effect-line-opacity': 0,
        duration: 0.5,
      },
      16,
    );

    tl.to(
      params5Ref.current,
      {
        '--effect-text-opacity': 0,
        duration: 0.5,
      },
      16.1,
    );

    tl.to(
      params6Ref.current,
      {
        '--effect-line-opacity': 0,
        duration: 0.5,
      },
      16,
    );

    tl.to(
      params6Ref.current,
      {
        '--effect-text-opacity': 0,
        duration: 0.5,
      },
      16.1,
    );

    tl.to(
      params7Ref.current,
      {
        '--effect-line-opacity': 0,
        duration: 0.5,
      },
      16,
    );

    tl.to(
      params7Ref.current,
      {
        '--effect-text-opacity': 0,
        duration: 0.5,
      },
      16.1,
    );

    //

    tl.to(
      text3Ref.current,
      {
        opacity: 0,
        duration: 1,
      },
      16,
    );

    tl.to(
      text4Ref.current,
      {
        y: 'var(--effect-offset-y)',
        duration: 2,
      },
      17,
    );

    tl.to(
      text4Ref.current,
      {
        opacity: 1,
        duration: 0.5,
      },
      17,
    );

    tl.to(
      xdbFrames,
      {
        frame: 182,
        snap: 'frame',
        onUpdate: render,
        duration: 5,
      },
      16,
    );

    tl.to(xdbFrames, {
      frame: 182,
      snap: 'frame',
      onUpdate: render,
      duration: 1,
    });
  };
  useEffect(() => {
    disinfectAnimation();
  }, []);

  return (
    <div className={styles.ctn} ref={ctnRef}>
      <div className={styles.mask} ref={maskRef}></div>
      {/* <div className={styles.productNameBox}>
        <h3 className={styles.slogan} ref={sloganRef}>
          首款消毒式防水音箱
        </h3>
        <div className={styles.productName} ref={productNameRef}>
          智云蓝牙消毒音箱
        </div>
      </div> */}

      <svg
        viewBox="0 0 1920 1080"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={styles.productNameBoxSvg}
      >
        <path
          d="M821.11 299.012H809.292C809.52 298.1 809.71 297.15 809.862 296.2H824.986V292.4H816.094C816.626 291.336 817.158 290.158 817.652 288.866L813.738 287.46C813.13 289.208 812.446 290.842 811.686 292.4H804.162C803.516 290.538 802.832 288.904 802.072 287.536L798.196 289.018C798.842 290.082 799.412 291.184 799.944 292.4H791.014V296.2H805.644C805.53 297.112 805.378 298.062 805.188 299.012H794.89V323.028H798.842V321.698H817.158V323.028H821.11V299.012ZM798.842 318.126V315.162H817.158V318.126H798.842ZM798.842 311.742V308.854H817.158V311.742H798.842ZM798.842 305.434V302.584H817.158V305.434H798.842ZM828.71 290.918V294.338H836.348V296.58H830.04V299.886H845.772V296.58H840.072V294.338H846.646V290.918H840.072V287.802H836.348V290.918H828.71ZM831.294 301.938V305.358H844.594V301.938H831.294ZM828.976 307.258V310.678H836.31V318.354C836.31 319.114 835.816 319.532 834.904 319.532C834.068 319.532 833.194 319.456 832.282 319.304L833.08 322.876H836.158C838.742 322.876 840.034 321.66 840.034 319.304V310.678H847.064V307.258H828.976ZM831.408 311.894C830.8 314.098 829.698 316.188 828.14 318.164L831.066 320.026C832.548 317.936 833.688 315.428 834.524 312.54L831.408 311.894ZM844.366 311.514L841.288 312.54C842.124 314.212 842.884 316.15 843.606 318.354L846.646 316.986C845.962 315.048 845.202 313.224 844.366 311.514ZM849.724 287.954C849.078 294.034 847.672 298.784 845.506 302.204L848.508 304.37C849.8 302.546 850.902 300.038 851.776 296.922H858.578C858.122 299.734 857.552 302.204 856.868 304.294L860.516 305.32C861.276 302.128 861.884 298.974 862.378 295.782V293.388H852.574C852.878 291.906 853.106 290.31 853.334 288.562L849.724 287.954ZM852.384 299.468C852.346 304.256 851.928 308.17 851.092 311.172C850.028 314.744 847.748 317.746 844.252 320.254L846.646 323.142C850.636 320.33 853.22 316.872 854.436 312.692C856.032 316.644 858.274 320.064 861.124 322.952L863.746 319.912C859.87 316.53 857.172 312.046 855.614 306.46C855.842 304.332 855.956 301.976 855.956 299.468H852.384ZM887.04 287.916V297.986H879.174V322.724H883.164V314.782H895.058V317.252C895.058 318.354 894.488 318.924 893.424 318.924L889.586 318.81L890.612 322.648H894.754C897.566 322.648 899.01 321.128 899.01 318.126V297.986H891.068V287.916H887.04ZM883.164 308.322H895.058V311.438H883.164V308.322ZM895.058 304.978H883.164V301.824H895.058V304.978ZM880.542 288.752L877.274 290.31C878.756 292.21 880.124 294.3 881.378 296.618L884.494 295.06C883.202 292.78 881.91 290.652 880.542 288.752ZM897.3 288.752C896.312 290.956 894.982 293.198 893.31 295.478L896.35 297.074C898.06 294.87 899.466 292.628 900.53 290.272L897.3 288.752ZM873.208 307.448C871.46 312.046 869.408 316.53 867.052 320.938L870.7 322.572C872.904 318.278 874.88 313.68 876.704 308.816L873.208 307.448ZM870.548 288.106L867.736 290.842C870.624 292.894 872.828 294.794 874.386 296.58L877.198 293.73C875.374 291.868 873.17 290.006 870.548 288.106ZM869.484 296.998L866.672 299.734C869.37 301.824 871.46 303.762 872.942 305.51L875.754 302.698C874.044 300.798 871.954 298.898 869.484 296.998ZM906.496 289.968V293.084H919.758V294.566H908.016V297.53H919.758V299.088H904.938V302.052H939.062V299.088H923.786V297.53H935.718V294.566H923.786V293.084H937.58V289.968H923.786V287.802H919.758V289.968H906.496ZM907.218 318.354H930.056L929.98 318.62C929.676 319.418 928.878 319.836 927.51 319.874C926.37 319.874 925.04 319.798 923.482 319.646L924.736 322.914L927.548 322.876C930.018 322.8 931.652 322.458 932.45 321.774C933.096 321.204 933.552 320.064 933.818 318.354H938.112V315.276H934.084C934.122 314.478 934.16 313.566 934.236 312.502H939.328V309.196H934.35C934.388 307.448 934.426 305.472 934.502 303.268H910.182C910.03 305.282 909.764 307.258 909.46 309.196H904.634V312.502H908.852C908.396 314.516 907.826 316.454 907.218 318.354ZM930.36 315.276H924.166C923.634 314.25 923.064 313.262 922.418 312.312H930.512C930.436 313.414 930.398 314.402 930.36 315.276ZM918.58 312.312C919.188 313.186 919.758 314.174 920.366 315.276H912.006C912.31 314.288 912.576 313.3 912.842 312.312H918.58ZM913.45 309.386C913.602 308.398 913.754 307.372 913.868 306.308H919.074C919.72 307.22 920.328 308.246 920.936 309.386H913.45ZM924.66 309.386C924.128 308.322 923.596 307.296 922.988 306.308H930.664L930.588 309.386H924.66ZM943.356 294.148V298.024H961.634C961.938 302.508 962.47 306.498 963.268 309.918C965.548 318.354 968.55 322.724 972.312 322.952C974.554 322.952 976.226 320.064 977.366 314.326L973.794 312.502C973.148 316.454 972.578 318.468 972.046 318.468C971.058 318.468 969.804 316.34 968.208 312.084C966.992 308.284 966.156 303.572 965.738 298.024H976.758V294.148H972.008L974.44 292.932C973.376 291.108 972.312 289.436 971.172 287.916L967.904 289.512C968.968 290.88 969.994 292.438 970.944 294.148H965.51C965.396 292.172 965.358 290.044 965.358 287.84H961.254C961.254 290.006 961.292 292.096 961.406 294.148H943.356ZM943.888 303.23V306.954H950.12V315.998C947.764 316.378 945.37 316.72 942.976 316.986L943.888 320.748C950.234 319.798 956.2 318.658 961.786 317.328V313.452C959.24 314.136 956.656 314.744 954.072 315.276V306.954H960.304V303.23H943.888ZM981.622 288.98V322.99H985.498V292.704H990.286C989.374 295.706 988.082 299.088 986.448 302.85C988.918 306.004 990.172 308.854 990.172 311.4C990.172 312.008 990.02 312.426 989.716 312.654C989.374 312.882 988.728 312.996 987.778 313.072C987.246 313.072 986.524 312.996 985.65 312.844L986.98 316.872C989.83 316.834 991.844 316.34 993.022 315.352C993.782 314.554 994.162 313.224 994.162 311.4C993.972 308.816 992.756 305.776 990.476 302.242C991.92 298.67 993.212 295.288 994.276 292.096V288.98H981.622ZM994.276 293.008V296.846H998.988C998.95 298.024 998.912 299.658 998.836 301.786C998.684 305.282 998.152 308.436 997.164 311.248C996.176 314.022 994.086 317.062 990.932 320.368L993.896 323.18C996.594 320.482 998.684 317.518 1000.2 314.288C1001.27 311.856 1002.03 309.196 1002.45 306.27H1009.51C1009.44 311.78 1009.32 315.162 1009.1 316.454C1008.68 318.05 1007.77 318.848 1006.4 318.886C1005.33 318.886 1004.08 318.81 1002.64 318.734L1003.93 322.42C1004.99 322.572 1005.94 322.648 1006.78 322.648C1009.67 322.61 1011.53 321.356 1012.36 318.848C1013.01 316.72 1013.39 311.248 1013.54 302.432H1002.75C1002.86 300.152 1002.94 298.29 1003.02 296.846H1015.06V293.008H1007.2C1006.66 291.032 1006.13 289.246 1005.6 287.726L1001.53 288.41C1002.14 289.816 1002.67 291.336 1003.21 293.008H994.276ZM1019.51 297.036V300.836H1028.21C1026.39 307.372 1023.08 312.464 1018.22 316.036L1020.72 319.304C1026.5 314.972 1030.3 308.588 1032.12 300.152V297.036H1019.51ZM1048.54 293.502C1046.26 296.58 1043.75 299.316 1040.98 301.748C1039.99 299.848 1039.08 297.834 1038.32 295.63V287.726H1034.29V317.556C1034.29 318.62 1033.87 319.19 1033.07 319.19C1031.63 319.19 1030.11 319.076 1028.51 318.924L1029.39 322.8H1034.44C1037.03 322.8 1038.32 321.394 1038.32 318.582V303.762C1041.13 309.538 1045.5 314.858 1051.43 319.76L1053.9 316.112C1049.41 313.148 1045.73 309.386 1042.8 304.826C1045.88 302.394 1048.84 299.43 1051.73 295.896L1048.54 293.502ZM1086.46 305.51H1061.69V322.99H1065.68V321.546H1082.47V322.99H1086.46V305.51ZM1065.68 318.126V315.238H1082.47V318.126H1065.68ZM1065.68 311.894V308.93H1082.47V311.894H1065.68ZM1058.88 291.108V294.756H1064.65C1065.26 296.276 1065.79 297.91 1066.32 299.658H1057.09V303.344H1090.91V299.658H1081.52C1082.28 298.1 1082.93 296.466 1083.42 294.756H1089.16V291.108H1076.13C1075.67 289.74 1075.18 288.524 1074.68 287.384L1070.43 288.068C1071 288.98 1071.53 290.006 1072.02 291.108H1058.88ZM1068.79 294.756H1079.47C1079.02 296.466 1078.41 298.1 1077.61 299.658H1070.2C1069.74 297.91 1069.29 296.276 1068.79 294.756ZM1095.51 301.938V305.738H1100.64C1099.19 308.93 1097.03 311.78 1094.1 314.288L1095.81 318.734C1098.02 316.226 1099.8 313.49 1101.21 310.526V323.028H1105.2V310.298C1106.11 311.59 1107.17 313.224 1108.39 315.124L1110.59 311.78C1108.77 309.842 1106.95 308.094 1105.2 306.498V305.738H1109.91V301.938H1105.2V298.29H1101.21V301.938H1095.51ZM1127.2 299.24H1111.24V322.99H1115.08V321.66H1123.36V322.99H1127.2V299.24ZM1115.08 318.164V314.972H1123.36V318.164H1115.08ZM1115.08 311.628V308.854H1123.36V311.628H1115.08ZM1115.08 305.51V302.736H1123.36V305.51H1115.08ZM1101.09 293.806H1102.77C1103.68 295.212 1104.51 296.694 1105.2 298.214L1108.85 296.846C1108.35 295.896 1107.74 294.87 1106.98 293.806H1111.96V290.31H1102.77C1102.99 289.74 1103.18 289.132 1103.41 288.524L1099.57 287.688C1098.66 290.5 1097.07 293.122 1094.82 295.554L1098.28 297.758C1099.31 296.542 1100.26 295.25 1101.09 293.806ZM1117.32 293.806H1119.11C1120.09 295.212 1120.93 296.656 1121.61 298.176L1125.11 296.846C1124.62 295.896 1123.97 294.87 1123.21 293.806H1129.29V290.31H1118.73C1118.92 289.664 1119.11 289.018 1119.33 288.334L1115.57 287.498C1114.77 290.462 1113.41 293.312 1111.47 295.972L1114.85 298.138C1115.76 296.808 1116.56 295.364 1117.32 293.806Z"
          fill="white"
        />
        <path
          d="M622.8 402.84H632.52C632.28 405.72 631.92 408.36 631.44 411H615.84C618.24 408.6 620.64 405.96 622.8 402.84ZM627.84 422.4C624.12 429.84 616.08 436.32 603.84 441.72L612.24 451.92C615.36 450.36 618.36 448.68 621.24 447V495.84H633.84V491.4H689.28V495.84H702V444.12H655.92L663 437.04C656.88 432.48 649.44 428.04 640.56 423.48L640.92 422.4H664.56V411H643.44C643.8 408.36 644.04 405.72 644.28 402.84H661.2V391.92H628.92C629.88 390 630.72 387.84 631.56 385.68L620.28 383.16C616.08 392.04 611.28 398.88 605.76 403.68L611.64 411H606.36V422.4H627.84ZM633.84 480.36V473.4H689.28V480.36H633.84ZM633.84 462.6V455.16H689.28V462.6H633.84ZM625.44 444.12C630 440.64 633.72 436.8 636.48 432.72C642.6 436.56 647.76 440.28 652.08 444.12H625.44ZM667.8 392.28V438.24H710.76V392.28H667.8ZM698.52 427.32H680.04V403.32H698.52V427.32ZM737.4 390.24V402.36H823.8V390.24H737.4ZM725.76 423.24V435.72H763.92C752.4 458.88 743.04 473.04 735.84 478.32C735.12 478.8 734.16 479.16 732.84 479.64L736.08 492.36C764.28 490.32 790.32 487.68 814.2 484.32C816.36 488.4 818.28 492.36 820.08 496.44L831.36 488.52C825.36 476.64 816.96 462.6 806.16 446.52L796.08 452.76C800.4 459.6 804.36 466.32 808.08 472.92C789.36 475.56 770.4 477.6 751.44 478.92C759.12 470.04 767.88 455.64 777.84 435.72H834.6V423.24H725.76ZM909.6 384.84V416.64H884.76V494.76H897.36V469.68H934.92V477.48C934.92 480.96 933.12 482.76 929.76 482.76L917.64 482.4L920.88 494.52H933.96C942.84 494.52 947.4 489.72 947.4 480.24V416.64H922.32V384.84H909.6ZM897.36 449.28H934.92V459.12H897.36V449.28ZM934.92 438.72H897.36V428.76H934.92V438.72ZM889.08 387.48L878.76 392.4C883.44 398.4 887.76 405 891.72 412.32L901.56 407.4C897.48 400.2 893.4 393.48 889.08 387.48ZM942 387.48C938.88 394.44 934.68 401.52 929.4 408.72L939 413.76C944.4 406.8 948.84 399.72 952.2 392.28L942 387.48ZM865.92 446.52C860.4 461.04 853.92 475.2 846.48 489.12L858 494.28C864.96 480.72 871.2 466.2 876.96 450.84L865.92 446.52ZM857.52 385.44L848.64 394.08C857.76 400.56 864.72 406.56 869.64 412.2L878.52 403.2C872.76 397.32 865.8 391.44 857.52 385.44ZM854.16 413.52L845.28 422.16C853.8 428.76 860.4 434.88 865.08 440.4L873.96 431.52C868.56 425.52 861.96 419.52 854.16 413.52ZM971.04 391.32V401.16H1012.92V405.84H975.84V415.2H1012.92V420.12H966.12V429.48H1073.88V420.12H1025.64V415.2H1063.32V405.84H1025.64V401.16H1069.2V391.32H1025.64V384.48H1012.92V391.32H971.04ZM973.32 480.96H1045.44L1045.2 481.8C1044.24 484.32 1041.72 485.64 1037.4 485.76C1033.8 485.76 1029.6 485.52 1024.68 485.04L1028.64 495.36L1037.52 495.24C1045.32 495 1050.48 493.92 1053 491.76C1055.04 489.96 1056.48 486.36 1057.32 480.96H1070.88V471.24H1058.16C1058.28 468.72 1058.4 465.84 1058.64 462.48H1074.72V452.04H1059C1059.12 446.52 1059.24 440.28 1059.48 433.32H982.68C982.2 439.68 981.36 445.92 980.4 452.04H965.16V462.48H978.48C977.04 468.84 975.24 474.96 973.32 480.96ZM1046.4 471.24H1026.84C1025.16 468 1023.36 464.88 1021.32 461.88H1046.88C1046.64 465.36 1046.52 468.48 1046.4 471.24ZM1009.2 461.88C1011.12 464.64 1012.92 467.76 1014.84 471.24H988.44C989.4 468.12 990.24 465 991.08 461.88H1009.2ZM993 452.64C993.48 449.52 993.96 446.28 994.32 442.92H1010.76C1012.8 445.8 1014.72 449.04 1016.64 452.64H993ZM1028.4 452.64C1026.72 449.28 1025.04 446.04 1023.12 442.92H1047.36L1047.12 452.64H1028.4ZM1179.36 440.4H1101.12V495.6H1113.72V491.04H1166.76V495.6H1179.36V440.4ZM1113.72 480.24V471.12H1166.76V480.24H1113.72ZM1113.72 460.56V451.2H1166.76V460.56H1113.72ZM1092.24 394.92V406.44H1110.48C1112.4 411.24 1114.08 416.4 1115.76 421.92H1086.6V433.56H1193.4V421.92H1163.76C1166.16 417 1168.2 411.84 1169.76 406.44H1187.88V394.92H1146.72C1145.28 390.6 1143.72 386.76 1142.16 383.16L1128.72 385.32C1130.52 388.2 1132.2 391.44 1133.76 394.92H1092.24ZM1123.56 406.44H1157.28C1155.84 411.84 1153.92 417 1151.4 421.92H1128C1126.56 416.4 1125.12 411.24 1123.56 406.44ZM1207.92 429.12V441.12H1224.12C1219.56 451.2 1212.72 460.2 1203.48 468.12L1208.88 482.16C1215.84 474.24 1221.48 465.6 1225.92 456.24V495.72H1238.52V455.52C1241.4 459.6 1244.76 464.76 1248.6 470.76L1255.56 460.2C1249.8 454.08 1244.04 448.56 1238.52 443.52V441.12H1253.4V429.12H1238.52V417.6H1225.92V429.12H1207.92ZM1308 420.6H1257.6V495.6H1269.72V491.4H1295.88V495.6H1308V420.6ZM1269.72 480.36V470.28H1295.88V480.36H1269.72ZM1269.72 459.72V450.96H1295.88V459.72H1269.72ZM1269.72 440.4V431.64H1295.88V440.4H1269.72ZM1225.56 403.44H1230.84C1233.72 407.88 1236.36 412.56 1238.52 417.36L1250.04 413.04C1248.48 410.04 1246.56 406.8 1244.16 403.44H1259.88V392.4H1230.84C1231.56 390.6 1232.16 388.68 1232.88 386.76L1220.76 384.12C1217.88 393 1212.84 401.28 1205.76 408.96L1216.68 415.92C1219.92 412.08 1222.92 408 1225.56 403.44ZM1276.8 403.44H1282.44C1285.56 407.88 1288.2 412.44 1290.36 417.24L1301.4 413.04C1299.84 410.04 1297.8 406.8 1295.4 403.44H1314.6V392.4H1281.24C1281.84 390.36 1282.44 388.32 1283.16 386.16L1271.28 383.52C1268.76 392.88 1264.44 401.88 1258.32 410.28L1269 417.12C1271.88 412.92 1274.4 408.36 1276.8 403.44Z"
          fill="white"
        />
      </svg>

      <canvas ref={canvasRef} className={styles.headerAnimate}></canvas>

      <svg
        viewBox="0 0 1920 1080"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={styles.paramsSvg}
      >
        <g className={styles.paramsItem} ref={params1Ref}>
          <rect x="1084" y="445" width="48" height="1" fill="white" />
          <path
            d="M1150.84 444.26H1156.45V442.532H1151.75C1151.84 442.28 1151.93 442.028 1152.04 441.776L1150.24 441.308C1149.7 442.712 1148.82 443.954 1147.58 444.998L1148.98 446.312C1149.67 445.754 1150.3 445.07 1150.84 444.26ZM1141.91 442.118V446.636H1143.78V442.118H1141.91ZM1145.35 441.578V447.212H1147.2V441.578H1145.35ZM1152.46 444.494L1151.29 445.574C1152.33 446.096 1153.32 446.726 1154.24 447.446L1155.39 446.114C1154.49 445.484 1153.52 444.944 1152.46 444.494ZM1141.1 438.284V440.03H1145V441.11H1146.91V440.03H1151.09V441.128H1153V440.03H1156.9V438.284H1153V437.222H1151.09V438.284H1146.91V437.222H1145V438.284H1141.1ZM1155.39 447.68H1142.61V451.766H1140.81V453.458H1157.19V451.766H1155.39V447.68ZM1144.43 451.766V449.372H1146.25V451.766H1144.43ZM1148.03 451.766V449.372H1149.92V451.766H1148.03ZM1151.7 451.766V449.372H1153.57V451.766H1151.7ZM1160.39 445.52H1167.13C1165.69 447.77 1162.95 449.786 1158.92 451.586L1159.91 453.206C1164.41 451.046 1167.45 448.49 1169 445.52H1169.27V451.316C1169.27 451.748 1169.03 451.982 1168.6 451.982C1167.77 451.982 1166.87 451.946 1165.94 451.874L1166.37 453.692H1169.25C1170.51 453.692 1171.16 453.062 1171.16 451.802V445.52H1175.03V443.72H1171.16V439.634H1174.06V437.798H1159.94V439.634H1169.27V443.72H1162.54C1162.75 442.82 1162.95 441.776 1163.13 440.606L1161.24 440.408C1161.06 441.884 1160.77 443.594 1160.39 445.52ZM1177.89 438.122V439.94H1181V443.774C1181 443.882 1180.99 443.972 1180.99 444.08H1176.97V445.898H1180.86C1180.72 447.122 1180.48 448.184 1180.16 449.084C1179.65 450.344 1178.68 451.406 1177.22 452.252L1178.25 453.854C1179.85 453.044 1181 451.874 1181.71 450.362C1182.23 449.156 1182.59 447.662 1182.77 445.898H1187.43V453.62H1189.32V445.898H1193.05V444.08H1189.32V439.94H1192.15V438.122H1177.89ZM1182.91 439.94H1187.43V444.08H1182.89C1182.89 443.972 1182.91 443.882 1182.91 443.774V439.94ZM1199.89 437.294L1198.16 438.122C1198.79 438.896 1199.38 439.778 1199.96 440.75H1196.21V442.586H1202.05V443.018C1202.01 443.846 1201.92 444.638 1201.78 445.358H1195.19V447.194H1201.24C1201.02 447.734 1200.75 448.238 1200.44 448.706C1199.47 450.056 1197.62 451.19 1194.85 452.09L1195.87 453.728C1198.64 452.864 1200.64 451.622 1201.87 450.002C1202.3 449.39 1202.68 448.688 1203 447.932C1204.06 450.398 1206.44 452.396 1210.15 453.908L1211.26 452.126C1207.7 450.902 1205.47 449.264 1204.6 447.194H1210.81V445.358H1203.7C1203.83 444.638 1203.92 443.846 1203.95 443.018V442.586H1209.77V440.75H1206.44C1207 439.832 1207.46 438.806 1207.86 437.672L1206.02 437.168C1205.54 438.536 1204.98 439.742 1204.33 440.75H1200.79L1201.83 440.228C1201.2 439.166 1200.55 438.194 1199.89 437.294Z"
            fill="white"
          />
        </g>

        <g className={styles.paramsItem} ref={params2Ref}>
          <rect x="1084" y="518" width="48" height="1" fill="white" />
          <path
            d="M1147.94 519.294C1148.95 518.646 1149.86 517.8 1150.6 516.846V519.024H1152.53V516.648C1153.32 517.656 1154.33 518.592 1155.37 519.294H1147.94ZM1152.4 524.37V523.326H1154.24V524.37H1152.4ZM1148.96 523.326H1150.64V524.37H1148.96V523.326ZM1150.64 521.85H1148.96V520.842H1150.64V521.85ZM1154.24 521.85H1152.4V520.842H1154.24V521.85ZM1150.6 514.236H1148.91L1149.9 513.894C1149.77 513.444 1149.43 512.742 1149.16 512.166C1149.65 512.148 1150.12 512.112 1150.6 512.076V514.236ZM1157.08 515.946V514.236H1155.03C1155.35 513.624 1155.73 512.922 1156.09 512.22L1154.26 511.734C1154 512.49 1153.54 513.48 1153.16 514.236H1152.53V511.914C1153.95 511.77 1155.32 511.59 1156.49 511.374L1155.37 509.826C1153.14 510.276 1149.49 510.6 1146.37 510.726C1146.55 511.14 1146.79 511.806 1146.84 512.256C1147.45 512.238 1148.08 512.22 1148.73 512.184L1147.43 512.58C1147.67 513.084 1147.94 513.732 1148.1 514.236H1146.32V515.946H1149.11C1148.33 516.828 1147.22 517.638 1146.05 518.16L1145.89 517.296L1144.57 517.728V515.118H1146.19V513.156H1144.57V509.772H1142.61V513.156H1140.72V515.136H1142.61V518.376C1141.78 518.61 1141.04 518.844 1140.41 519.024L1140.79 521.094L1142.61 520.464V524.298C1142.61 524.532 1142.52 524.604 1142.3 524.604C1142.09 524.622 1141.48 524.622 1140.81 524.586C1141.08 525.162 1141.31 526.044 1141.37 526.566C1142.54 526.584 1143.31 526.512 1143.85 526.17C1144.39 525.828 1144.57 525.288 1144.57 524.298V519.798C1145.11 519.6 1145.63 519.402 1146.17 519.204C1146.39 519.474 1146.57 519.744 1146.7 519.96C1146.82 519.906 1146.95 519.852 1147.07 519.78V526.53H1148.96V525.864H1154.24V526.458H1156.22V519.78L1156.31 519.834C1156.61 519.348 1157.21 518.646 1157.64 518.304C1156.4 517.8 1155.07 516.9 1154.15 515.946H1157.08ZM1169.63 514.992H1171.99C1171.75 516.666 1171.39 518.124 1170.87 519.402C1170.31 518.106 1169.9 516.63 1169.59 515.064L1169.63 514.992ZM1175.44 514.992V513.012H1170.22C1170.47 512.076 1170.67 511.086 1170.83 510.096L1168.66 509.754C1168.22 512.652 1167.4 515.424 1166.08 517.242V517.098C1166.1 516.846 1166.1 516.234 1166.1 516.234H1162.54V514.47H1166.69V512.49H1162.77L1164.25 512.058C1164.07 511.428 1163.71 510.438 1163.38 509.7L1161.49 510.15C1161.76 510.87 1162.09 511.806 1162.23 512.49H1158.76V514.47H1160.52V517.944C1160.52 520.266 1160.25 522.84 1158.32 525.072C1158.85 525.432 1159.55 526.008 1159.89 526.476C1162.12 524.01 1162.52 521.022 1162.54 518.178H1164.05C1163.98 522.39 1163.87 523.902 1163.63 524.298C1163.49 524.514 1163.35 524.568 1163.13 524.568C1162.84 524.568 1162.32 524.55 1161.74 524.514C1162.05 525.054 1162.25 525.864 1162.3 526.458C1163.06 526.476 1163.76 526.458 1164.23 526.386C1164.75 526.278 1165.07 526.098 1165.43 525.594C1165.88 524.982 1165.97 523.038 1166.06 518.034C1166.53 518.484 1167.07 519.078 1167.32 519.42C1167.68 518.97 1168.01 518.502 1168.31 517.944C1168.69 519.294 1169.11 520.536 1169.66 521.652C1168.73 522.948 1167.47 523.974 1165.81 524.73C1166.21 525.18 1166.82 526.134 1167 526.602C1168.58 525.792 1169.83 524.784 1170.82 523.56C1171.72 524.766 1172.81 525.738 1174.18 526.458C1174.51 525.882 1175.17 525.054 1175.66 524.622C1174.16 523.938 1173.01 522.93 1172.11 521.634C1173.08 519.816 1173.71 517.602 1174.09 514.992H1175.44ZM1191.19 512.616V513.462H1190.22V512.616H1191.19ZM1191.19 515.874H1190.22V515.01H1191.19V515.874ZM1188.53 513.462H1186.06V515.01H1188.53V515.874H1186.8V517.404H1188.53V518.214H1186.66V519.888H1188.53V520.752H1186.28V522.408H1188.53V524.01H1190.22V522.408H1192.9V520.752H1190.22V519.888H1192.61V518.214H1190.22V517.404H1192.76V515.01H1193.32V513.462H1192.76V511.086H1190.22V509.754H1188.53V511.086H1186.8V512.616H1188.53V513.462ZM1180.37 522.93V520.338H1182.07V518.52H1180.37V516.648H1181.69V514.848H1177.94C1178.23 514.38 1178.52 513.894 1178.77 513.354H1182.12V511.518H1179.51C1179.65 511.086 1179.8 510.672 1179.91 510.258L1178.27 509.808C1177.87 511.356 1177.22 512.886 1176.41 513.912C1176.72 514.326 1177.15 515.298 1177.3 515.712C1177.44 515.55 1177.57 515.388 1177.69 515.208V516.648H1178.65V518.52H1176.9V520.338H1178.65V523.308C1178.65 524.244 1178.14 524.874 1177.8 525.18C1178.09 525.432 1178.57 526.08 1178.75 526.44V526.386L1178.77 526.44C1179.06 526.044 1179.58 525.612 1182.46 523.488C1182.25 523.128 1181.98 522.39 1181.85 521.868L1180.37 522.93ZM1185.47 516.108L1185.18 516.126H1184.73C1185.29 514.506 1185.9 512.544 1186.35 510.888H1182.52V512.634H1184.08C1183.56 514.452 1182.91 516.414 1182.41 517.764H1184.73C1184.6 518.862 1184.44 519.834 1184.23 520.716C1184.05 520.248 1183.88 519.744 1183.74 519.186L1182.17 519.726C1182.52 521.022 1182.93 522.066 1183.43 522.912C1182.91 523.956 1182.28 524.766 1181.47 525.378C1181.89 525.576 1182.55 526.17 1182.82 526.53C1183.49 525.99 1184.08 525.288 1184.55 524.388C1186.04 525.864 1187.93 526.278 1190.18 526.278H1192.96C1193.05 525.756 1193.32 524.928 1193.59 524.478C1192.85 524.496 1190.9 524.496 1190.33 524.496C1188.38 524.496 1186.64 524.1 1185.34 522.642C1185.95 520.968 1186.31 518.88 1186.51 516.324L1185.47 516.108Z"
            fill="white"
          />
        </g>

        <g className={styles.paramsItem} ref={params3Ref}>
          <rect x="1084" y="587" width="48" height="1" fill="white" />
          <path
            d="M1150.44 579.276V584.046H1146.71V595.764H1148.6V592.002H1154.24V593.172C1154.24 593.694 1153.97 593.964 1153.46 593.964L1151.65 593.91L1152.13 595.728H1154.09C1155.43 595.728 1156.11 595.008 1156.11 593.586V584.046H1152.35V579.276H1150.44ZM1148.6 588.942H1154.24V590.418H1148.6V588.942ZM1154.24 587.358H1148.6V585.864H1154.24V587.358ZM1147.36 579.672L1145.81 580.41C1146.52 581.31 1147.16 582.3 1147.76 583.398L1149.23 582.66C1148.62 581.58 1148.01 580.572 1147.36 579.672ZM1155.3 579.672C1154.83 580.716 1154.2 581.778 1153.41 582.858L1154.85 583.614C1155.66 582.57 1156.33 581.508 1156.83 580.392L1155.3 579.672ZM1143.89 588.528C1143.06 590.706 1142.09 592.83 1140.97 594.918L1142.7 595.692C1143.74 593.658 1144.68 591.48 1145.54 589.176L1143.89 588.528ZM1142.63 579.366L1141.3 580.662C1142.66 581.634 1143.71 582.534 1144.45 583.38L1145.78 582.03C1144.91 581.148 1143.87 580.266 1142.63 579.366ZM1142.12 583.578L1140.79 584.874C1142.07 585.864 1143.06 586.782 1143.76 587.61L1145.09 586.278C1144.28 585.378 1143.29 584.478 1142.12 583.578ZM1159.66 580.248V581.724H1165.94V582.426H1160.38V583.83H1165.94V584.568H1158.92V585.972H1175.08V584.568H1167.85V583.83H1173.5V582.426H1167.85V581.724H1174.38V580.248H1167.85V579.222H1165.94V580.248H1159.66ZM1160 593.694H1170.82L1170.78 593.82C1170.64 594.198 1170.26 594.396 1169.61 594.414C1169.07 594.414 1168.44 594.378 1167.7 594.306L1168.3 595.854L1169.63 595.836C1170.8 595.8 1171.57 595.638 1171.95 595.314C1172.26 595.044 1172.47 594.504 1172.6 593.694H1174.63V592.236H1172.72C1172.74 591.858 1172.76 591.426 1172.8 590.922H1175.21V589.356H1172.85C1172.87 588.528 1172.89 587.592 1172.92 586.548H1161.4C1161.33 587.502 1161.2 588.438 1161.06 589.356H1158.77V590.922H1160.77C1160.56 591.876 1160.29 592.794 1160 593.694ZM1170.96 592.236H1168.03C1167.77 591.75 1167.5 591.282 1167.2 590.832H1171.03C1171 591.354 1170.98 591.822 1170.96 592.236ZM1165.38 590.832C1165.67 591.246 1165.94 591.714 1166.23 592.236H1162.27C1162.41 591.768 1162.54 591.3 1162.66 590.832H1165.38ZM1162.95 589.446C1163.02 588.978 1163.09 588.492 1163.15 587.988H1165.61C1165.92 588.42 1166.21 588.906 1166.5 589.446H1162.95ZM1168.26 589.446C1168.01 588.942 1167.76 588.456 1167.47 587.988H1171.1L1171.07 589.446H1168.26ZM1177.89 580.122V581.94H1181V585.774C1181 585.882 1180.99 585.972 1180.99 586.08H1176.97V587.898H1180.86C1180.72 589.122 1180.48 590.184 1180.16 591.084C1179.65 592.344 1178.68 593.406 1177.22 594.252L1178.25 595.854C1179.85 595.044 1181 593.874 1181.71 592.362C1182.23 591.156 1182.59 589.662 1182.77 587.898H1187.43V595.62H1189.32V587.898H1193.05V586.08H1189.32V581.94H1192.15V580.122H1177.89ZM1182.91 581.94H1187.43V586.08H1182.89C1182.89 585.972 1182.91 585.882 1182.91 585.774V581.94ZM1199.89 579.294L1198.16 580.122C1198.79 580.896 1199.38 581.778 1199.96 582.75H1196.21V584.586H1202.05V585.018C1202.01 585.846 1201.92 586.638 1201.78 587.358H1195.19V589.194H1201.24C1201.02 589.734 1200.75 590.238 1200.44 590.706C1199.47 592.056 1197.62 593.19 1194.85 594.09L1195.87 595.728C1198.64 594.864 1200.64 593.622 1201.87 592.002C1202.3 591.39 1202.68 590.688 1203 589.932C1204.06 592.398 1206.44 594.396 1210.15 595.908L1211.26 594.126C1207.7 592.902 1205.47 591.264 1204.6 589.194H1210.81V587.358H1203.7C1203.83 586.638 1203.92 585.846 1203.95 585.018V584.586H1209.77V582.75H1206.44C1207 581.832 1207.46 580.806 1207.86 579.672L1206.02 579.168C1205.54 580.536 1204.98 581.742 1204.33 582.75H1200.79L1201.83 582.228C1201.2 581.166 1200.55 580.194 1199.89 579.294Z"
            fill="white"
          />
        </g>

        <g className={styles.paramsItem} ref={params4Ref}>
          <rect x="1084" y="656" width="48" height="1" fill="white" />
          <path
            d="M1152.78 658.104V659.292H1145.31V658.104H1152.78ZM1145.31 662.208V660.912H1152.78V662.208H1145.31ZM1143.17 664.602H1145.31V663.972H1152.78V664.584H1155.03V656.322H1143.17V664.602ZM1151.74 651.102C1151.54 651.804 1151.21 652.65 1150.93 653.316H1147.22C1147.09 652.668 1146.73 651.786 1146.3 651.102H1151.74ZM1153.27 653.316C1153.55 652.758 1153.86 652.128 1154.17 651.462L1152.51 651.102H1156.24V649.212H1150.44C1150.26 648.672 1149.99 648.06 1149.68 647.556L1147.45 647.916C1147.65 648.294 1147.87 648.762 1148.01 649.212H1141.94V651.102H1145.9L1144.16 651.444C1144.45 652.002 1144.72 652.704 1144.88 653.316H1140.94V655.224H1157.08V653.316H1153.27ZM1170.65 650.04H1163.18V649.41H1170.65V650.04ZM1170.65 651.678H1163.18V651.03H1170.65V651.678ZM1172.81 648.312H1161.13V652.776H1172.81V648.312ZM1175.14 653.28H1158.86V654.828H1175.14V653.28ZM1162.81 658.806V658.158H1165.94V658.806H1162.81ZM1162.81 656.502H1165.94V657.132H1162.81V656.502ZM1171.14 657.132H1167.99V656.502H1171.14V657.132ZM1171.14 658.806H1167.99V658.158H1171.14V658.806ZM1167.99 662.55V661.92H1173.5V660.534H1167.99V659.958H1173.25V655.35H1160.81V659.958H1165.94V660.534H1160.43V661.92H1165.94V662.55H1158.83V664.116H1175.19V662.55H1167.99ZM1191.19 650.616V651.462H1190.22V650.616H1191.19ZM1191.19 653.874H1190.22V653.01H1191.19V653.874ZM1188.53 651.462H1186.06V653.01H1188.53V653.874H1186.8V655.404H1188.53V656.214H1186.66V657.888H1188.53V658.752H1186.28V660.408H1188.53V662.01H1190.22V660.408H1192.9V658.752H1190.22V657.888H1192.61V656.214H1190.22V655.404H1192.76V653.01H1193.32V651.462H1192.76V649.086H1190.22V647.754H1188.53V649.086H1186.8V650.616H1188.53V651.462ZM1180.37 660.93V658.338H1182.07V656.52H1180.37V654.648H1181.69V652.848H1177.94C1178.23 652.38 1178.52 651.894 1178.77 651.354H1182.12V649.518H1179.51C1179.65 649.086 1179.8 648.672 1179.91 648.258L1178.27 647.808C1177.87 649.356 1177.22 650.886 1176.41 651.912C1176.72 652.326 1177.15 653.298 1177.3 653.712C1177.44 653.55 1177.57 653.388 1177.69 653.208V654.648H1178.65V656.52H1176.9V658.338H1178.65V661.308C1178.65 662.244 1178.14 662.874 1177.8 663.18C1178.09 663.432 1178.57 664.08 1178.75 664.44V664.386L1178.77 664.44C1179.06 664.044 1179.58 663.612 1182.46 661.488C1182.25 661.128 1181.98 660.39 1181.85 659.868L1180.37 660.93ZM1185.47 654.108L1185.18 654.126H1184.73C1185.29 652.506 1185.9 650.544 1186.35 648.888H1182.52V650.634H1184.08C1183.56 652.452 1182.91 654.414 1182.41 655.764H1184.73C1184.6 656.862 1184.44 657.834 1184.23 658.716C1184.05 658.248 1183.88 657.744 1183.74 657.186L1182.17 657.726C1182.52 659.022 1182.93 660.066 1183.43 660.912C1182.91 661.956 1182.28 662.766 1181.47 663.378C1181.89 663.576 1182.55 664.17 1182.82 664.53C1183.49 663.99 1184.08 663.288 1184.55 662.388C1186.04 663.864 1187.93 664.278 1190.18 664.278H1192.96C1193.05 663.756 1193.32 662.928 1193.59 662.478C1192.85 662.496 1190.9 662.496 1190.33 662.496C1188.38 662.496 1186.64 662.1 1185.34 660.642C1185.95 658.968 1186.31 656.88 1186.51 654.324L1185.47 654.108Z"
            fill="white"
          />
        </g>

        <g className={styles.paramsItem} ref={params5Ref}>
          <path
            d="M770.468 506.038C772.646 505.606 774.95 504.94 777.398 504.076L776.354 502.6C774.482 503.356 772.52 503.968 770.468 504.4V502.276H768.65V507.154C768.65 508.45 769.244 509.098 770.45 509.098H775.67C776.408 509.098 776.948 508.954 777.308 508.666C777.686 508.378 777.956 507.46 778.118 505.93L776.39 505.372C776.318 506.344 776.21 506.92 776.03 507.1C775.868 507.28 775.634 507.37 775.328 507.37H771.008C770.648 507.37 770.468 507.154 770.468 506.758V506.038ZM764.24 518.71C765.428 518.71 766.04 518.098 766.04 516.874V512.104C766.688 511.852 767.336 511.582 767.984 511.294V509.386C767.354 509.692 766.706 509.98 766.04 510.232V507.262H767.84V505.48H766.04V502.294H764.222V505.48H762.008V507.262H764.222V510.862C763.376 511.114 762.512 511.33 761.648 511.51L762.116 513.4C762.818 513.202 763.52 512.986 764.222 512.752V516.388C764.222 516.82 764.006 517.036 763.592 517.036C763.088 517.036 762.53 517 761.954 516.928L762.368 518.71H764.24ZM777.452 510.124H768.794V518.89H770.648V518.134H775.562V518.89H777.452V510.124ZM770.648 516.478V514.93H775.562V516.478H770.648ZM770.648 513.274V511.762H775.562V513.274H770.648ZM786.992 518.656C788.324 518.656 788.99 518.008 788.99 516.748V509.386H795.758V507.532H780.242V509.386H787.082V516.262C787.082 516.712 786.83 516.946 786.344 516.946C785.696 516.946 784.994 516.91 784.274 516.838L784.67 518.656H786.992ZM782.78 511.042C782.222 513.094 781.268 515.038 779.9 516.874L781.538 517.9C782.87 516.1 783.914 513.94 784.634 511.456L782.78 511.042ZM792.914 510.808L791.222 511.384C792.338 513.22 793.382 515.344 794.318 517.756L796.028 516.982C795.164 514.786 794.12 512.734 792.914 510.808ZM781.898 502.996V504.832H794.156V502.996H781.898ZM798.26 505.462C798.224 507.19 798.026 508.828 797.684 510.376L799.25 510.826C799.61 509.17 799.808 507.424 799.844 505.588L798.26 505.462ZM804.092 504.688C803.606 505.444 803.012 506.164 802.31 506.884V502.438H800.51V509.134C800.474 512.986 799.574 515.776 797.81 517.522L799.232 518.764C800.456 517.54 801.302 515.866 801.806 513.778C802.346 514.498 803.03 515.506 803.858 516.802L804.956 515.128C804.002 513.94 803.066 512.86 802.13 511.906C802.238 511.042 802.292 510.106 802.31 509.134V508.882C803.48 507.964 804.434 507.028 805.154 506.074L804.092 504.688ZM804.884 503.158V504.976H809.33V516.442C809.33 516.838 809.096 517.054 808.646 517.054C807.944 517.054 807.188 517 806.396 516.928L806.828 518.728H809.312C810.554 518.728 811.184 518.116 811.184 516.91V504.976H814.262V503.158H804.884Z"
            fill="white"
          />
          <rect x="823" y="510" width="48" height="1" fill="white" />
        </g>

        <g className={styles.paramsItem} ref={params6Ref}>
          <path
            d="M764.942 557.106H768.758V559.176H764.942V557.106ZM768.758 560.922V562.866C768.758 564.684 769.604 565.602 771.314 565.602H775.922C776.822 565.602 777.434 565.44 777.776 565.134C778.1 564.792 778.316 563.838 778.442 562.29L776.642 561.696C776.588 562.758 776.498 563.388 776.354 563.586C776.192 563.766 775.94 563.856 775.598 563.856H771.746C771.008 563.856 770.648 563.424 770.648 562.578V560.922H776.444V551.526H770.648V549.258H768.758V551.526H763.07V562.308H764.942V560.922H768.758ZM770.648 559.176V557.106H774.59V559.176H770.648ZM774.59 555.378H770.648V553.29H774.59V555.378ZM768.758 553.29V555.378H764.942V553.29H768.758ZM781.268 549.474L780.008 550.68C781.394 551.688 782.456 552.606 783.212 553.47L784.49 552.21C783.608 551.31 782.528 550.392 781.268 549.474ZM780.944 553.884L779.684 555.09C780.98 556.062 781.988 556.962 782.672 557.79L783.932 556.512C783.122 555.648 782.132 554.766 780.944 553.884ZM782.528 558.816C781.772 560.94 780.89 563.01 779.846 565.062L781.592 565.836C782.528 563.856 783.392 561.732 784.148 559.464L782.528 558.816ZM787.604 552.696V559.374H790.502V563.586C790.502 564.018 790.322 564.234 789.998 564.234C789.566 564.234 789.134 564.198 788.702 564.126L789.098 565.818H790.61C791.726 565.818 792.284 565.224 792.284 564.036V559.374H795.11V552.696H791.798C791.942 552.282 792.05 551.868 792.158 551.436H795.992V549.78H784.922V555.936C784.868 559.644 784.31 562.56 783.23 564.648L784.652 565.908C785.966 563.388 786.65 560.076 786.722 555.936V551.436H790.394C790.304 551.85 790.178 552.264 790.034 552.696H787.604ZM793.472 557.898H789.242V556.71H793.472V557.898ZM789.242 555.36V554.136H793.472V555.36H789.242ZM787.82 560.4C787.496 561.678 786.938 562.884 786.146 564L787.658 564.954C788.45 563.766 789.044 562.38 789.476 560.76L787.82 560.4ZM794.552 560.292L793.004 560.832C793.616 562.02 794.192 563.388 794.714 564.936L796.298 564.234C795.794 562.83 795.218 561.516 794.552 560.292ZM798.746 555.954V556.386H799.952V558.096H798.116V559.788H799.952V563.19C799.952 563.514 799.754 563.748 799.358 563.91L800.096 565.476C801.338 565.008 802.436 564.432 803.39 563.748L803.084 562.164C802.598 562.578 802.112 562.92 801.644 563.208V559.788H803.3V559.662C803.624 560.742 804.02 561.678 804.506 562.47C804.146 563.262 803.678 563.964 803.102 564.54L804.362 565.8C804.848 565.26 805.28 564.63 805.64 563.928C805.928 564.18 806.234 564.414 806.558 564.63C807.566 565.242 809.456 565.566 812.228 565.602H814.01L814.352 563.82C813.326 563.874 812.318 563.91 811.31 563.91C809.69 563.838 808.466 563.604 807.674 563.244C807.188 563.01 806.738 562.686 806.324 562.254C806.828 560.706 807.098 558.87 807.134 556.71V555.72H805.478C805.982 554.748 806.486 553.596 807.026 552.264V550.752H803.606V552.336H805.352C804.812 553.596 804.236 554.802 803.588 555.936V557.214H805.64C805.568 558.42 805.424 559.518 805.172 560.508C804.848 559.86 804.614 559.14 804.452 558.366L803.3 558.798V558.096H801.644V556.386H803.03V554.73H799.556C799.772 554.136 799.988 553.506 800.186 552.84H803.012V551.058H800.654C800.762 550.59 800.852 550.086 800.96 549.546L799.196 549.168C798.872 551.292 798.332 553.308 797.54 555.18L798.746 555.954ZM813.416 557.07V554.568H814.118V553.092H813.416V550.518H810.932V549.33H809.258V550.518H807.674V551.994H809.258V553.092H807.08V554.568H809.258V555.594H807.71V557.07H809.258V558.06H807.566V559.5H809.258V560.544H807.116V562.056H809.258V563.388H810.932V562.056H813.974V560.544H810.932V559.5H813.542V558.06H810.932V557.07H813.416ZM810.932 551.994H811.868V553.092H810.932V551.994ZM810.932 554.568H811.868V555.594H810.932V554.568Z"
            fill="white"
          />
          <rect x="823" y="557" width="48" height="1" fill="white" />
        </g>

        <g className={styles.paramsItem} ref={params7Ref}>
          <path
            d="M770.252 596.096L768.236 596.42C768.56 596.96 768.866 597.536 769.154 598.166H762.512V599.912H767.282C765.986 601.748 764.942 602.9 764.114 603.332C764.024 603.386 763.898 603.44 763.718 603.476L764.15 605.168C767.84 604.97 771.26 604.7 774.392 604.358C774.806 604.97 775.184 605.582 775.526 606.176L777.074 605.078C776.282 603.764 775.13 602.216 773.654 600.434L772.196 601.352C772.574 601.838 772.952 602.342 773.33 602.846C771.062 603.116 768.812 603.314 766.544 603.458C767.336 602.666 768.218 601.496 769.226 599.912H777.488V598.166H771.062C770.81 597.41 770.54 596.708 770.252 596.096ZM766.544 605.69C766.436 607.4 766.058 608.624 765.428 609.38C764.762 610.136 763.646 610.802 762.08 611.36L763.268 612.872C765.068 612.116 766.346 611.234 767.12 610.226C767.804 609.272 768.218 607.76 768.362 605.69H766.544ZM775.634 612.584C776.282 612.548 776.786 612.386 777.164 612.062C777.488 611.756 777.74 610.658 777.938 608.75L776.21 608.21C776.12 609.596 775.976 610.388 775.778 610.568C775.562 610.748 775.364 610.838 775.166 610.838H773.24C772.754 610.838 772.52 610.586 772.52 610.1V605.474H770.648V610.424C770.648 611.864 771.332 612.584 772.718 612.584H775.634ZM782.942 604.106H786.758V606.176H782.942V604.106ZM786.758 607.922V609.866C786.758 611.684 787.604 612.602 789.314 612.602H793.922C794.822 612.602 795.434 612.44 795.776 612.134C796.1 611.792 796.316 610.838 796.442 609.29L794.642 608.696C794.588 609.758 794.498 610.388 794.354 610.586C794.192 610.766 793.94 610.856 793.598 610.856H789.746C789.008 610.856 788.648 610.424 788.648 609.578V607.922H794.444V598.526H788.648V596.258H786.758V598.526H781.07V609.308H782.942V607.922H786.758ZM788.648 606.176V604.106H792.59V606.176H788.648ZM792.59 602.378H788.648V600.29H792.59V602.378ZM786.758 600.29V602.378H782.942V600.29H786.758ZM812.804 598.184H799.214V612.584H801.104V611.612H810.896V612.584H812.804V598.184ZM801.104 609.776V600.02H810.896V609.776H801.104Z"
            fill="white"
          />
          <rect x="823" y="604" width="48" height="1" fill="white" />
        </g>
      </svg>

      <div className={styles.textBox}>
        {/* <div ref={text1HRef} className={styles.text1H}>
          <svg
            width="48"
            height="48"
            viewBox="0 0 48 48"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <g clip-path="url(#clip0_483_940)">
              <path
                d="M17.8715 37.964H30.1285C28.9708 40.6913 26.7691 42.8597 24 44C21.2309 42.8597 19.0292 40.6913 17.8715 37.964ZM34.5 29.0099L38 32.919V36.2404H10V32.919L13.5 29.0099V19.0045C13.5 13.0012 17.882 7.8925 24 6C30.118 7.8925 34.5 13.0012 34.5 19.0045V29.0099ZM24 22.4517C24.9283 22.4517 25.8185 22.0885 26.4749 21.442C27.1313 20.7955 27.5 19.9187 27.5 19.0045C27.5 18.0902 27.1313 17.2134 26.4749 16.567C25.8185 15.9205 24.9283 15.5573 24 15.5573C23.0717 15.5573 22.1815 15.9205 21.5251 16.567C20.8687 17.2134 20.5 18.0902 20.5 19.0045C20.5 19.9187 20.8687 20.7955 21.5251 21.442C22.1815 22.0885 23.0717 22.4517 24 22.4517Z"
                fill="white"
              />
              <path
                opacity="0.4"
                d="M3.5999 39.3066C3.70998 38.8978 4.29002 38.8978 4.4001 39.3066L4.94366 41.3254C5.03964 41.6819 5.3181 41.9604 5.67459 42.0563L7.69338 42.5999C8.10221 42.71 8.10221 43.29 7.69338 43.4001L5.67459 43.9437C5.3181 44.0396 5.03964 44.3181 4.94366 44.6746L4.4001 46.6934C4.29002 47.1022 3.70998 47.1022 3.5999 46.6934L3.05634 44.6746C2.96036 44.3181 2.6819 44.0396 2.32541 43.9437L0.306623 43.4001C-0.102208 43.29 -0.102207 42.71 0.306624 42.5999L2.32541 42.0563C2.6819 41.9604 2.96036 41.6819 3.05634 41.3254L3.5999 39.3066Z"
                fill="white"
              />
              <path
                d="M41.3998 0.459934C41.565 -0.153312 42.435 -0.153311 42.6002 0.459935L43.4155 3.48811C43.5595 4.02285 43.9772 4.44054 44.5119 4.58452L47.5401 5.39985C48.1533 5.56496 48.1533 6.43503 47.5401 6.60015L44.5119 7.41548C43.9771 7.55946 43.5595 7.97715 43.4155 8.51189L42.6002 11.5401C42.435 12.1533 41.565 12.1533 41.3998 11.5401L40.5845 8.51189C40.4405 7.97715 40.0228 7.55946 39.4881 7.41548L36.4599 6.60015C35.8467 6.43503 35.8467 5.56496 36.4599 5.39985L39.4881 4.58452C40.0228 4.44054 40.4405 4.02285 40.5845 3.48811L41.3998 0.459934Z"
                fill="white"
              />
            </g>
            <defs>
              <clipPath id="clip0_483_940">
                <rect width="48" height="48" fill="white" />
              </clipPath>
            </defs>
          </svg>
        </div> */}
        <h3
          ref={text1PRef}
          className={styles.text1P}
          dangerouslySetInnerHTML={{
            __html: DOMPurify.sanitize(textData['text2']),
          }}
        ></h3>

        <div
          className={styles.watchVideoButton}
          ref={watchVideoButtonRef}
          data-video-src={`http://zhiyun-website-shenzhen.oss-cn-shenzhen.aliyuncs.com/detail/ozone-speaker/zhiyunlife-ozonespeaker-tvc-${
            language === 'cn' ? 'cn' : 'en'
          }.mp4`}
        >
          <svg
            width="18"
            height="18"
            viewBox="0 0 18 18"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M5 14.1783V3.82167C5 3.03258 5.87115 2.55437 6.53688 2.97801L14.6742 8.15634C15.2917 8.54929 15.2917 9.45071 14.6742 9.84366L6.53688 15.022C5.87115 15.4456 5 14.9674 5 14.1783Z"
              fill="#FF4D4D"
            />
          </svg>

          <div
            dangerouslySetInnerHTML={{
              __html: DOMPurify.sanitize(textData['text1']),
            }}
          ></div>
        </div>
      </div>
      <h1
        ref={text2HRef}
        className={styles.text2H}
        dangerouslySetInnerHTML={{
          __html: DOMPurify.sanitize(textData['text3']),
        }}
      ></h1>
      <h3
        ref={text3Ref}
        className={styles.text3}
        dangerouslySetInnerHTML={{
          __html: DOMPurify.sanitize(textData['text4']),
        }}
      ></h3>
      <h3
        ref={text4Ref}
        className={styles.text4}
        dangerouslySetInnerHTML={{
          __html: DOMPurify.sanitize(textData['text5']),
        }}
      ></h3>
    </div>
  );
};
export default DisinfectVideo;
